/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    '7khawgSwbvfj37CCHob555.png': { uri: '/images/7khawgSwbvfj37CCHob555.png' },
'fYxNXsDANxEWkuEfNbWEpc.png': { uri: '/images/fYxNXsDANxEWkuEfNbWEpc.png' },
'dy6MZsVix1QDZWnurMHVUp.png': { uri: '/images/dy6MZsVix1QDZWnurMHVUp.png' },
'cjTiZKFE3oCRHXbUc2Zxuf.png': { uri: '/images/cjTiZKFE3oCRHXbUc2Zxuf.png' },
'3WoYMhMc9kqpVMbD3cZ6Z4.jpg': { uri: '/images/3WoYMhMc9kqpVMbD3cZ6Z4.jpg' },
'153C5FAiL4pQRYfu3tx7pV.png': { uri: '/images/153C5FAiL4pQRYfu3tx7pV.png' },
'kE5HAGA8g4JrK5Fa39LmHy.png': { uri: '/images/kE5HAGA8g4JrK5Fa39LmHy.png' },
'f5TFYoGobfTyPnByaaEUQJ.png': { uri: '/images/f5TFYoGobfTyPnByaaEUQJ.png' },
'k28ecpKwHocGqHVhZgURZi.png': { uri: '/images/k28ecpKwHocGqHVhZgURZi.png' },
'ikFvcKNzDkhdXNxjCL9FMR.png': { uri: '/images/ikFvcKNzDkhdXNxjCL9FMR.png' },
'v3QpQcZ3eULF2P5rGu1f6h.png': { uri: '/images/v3QpQcZ3eULF2P5rGu1f6h.png' },
'hq4cXG587oaCi7UcWZTdzE.png': { uri: '/images/hq4cXG587oaCi7UcWZTdzE.png' },
'qCeRuAKPkTqVrUif3PXKa4.png': { uri: '/images/qCeRuAKPkTqVrUif3PXKa4.png' },
'gH32snFEjhGKEZC28Znb4s.png': { uri: '/images/gH32snFEjhGKEZC28Znb4s.png' },
'vPJBY3Wpu4FEqL3QSWaeVX.png': { uri: '/images/vPJBY3Wpu4FEqL3QSWaeVX.png' }
}

export default imageStaticSourcesByFileName
